var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 29.3334H20.0001M6.66676 12C6.66676 6.84536 10.8454 2.66669 16.0001 2.66669C21.1548 2.66669 25.3334 6.84536 25.3334 12V15.4371C25.3334 17.5429 25.9568 19.6017 27.1249 21.3539L27.7777 22.3331C27.8897 22.5011 27.8113 22.7296 27.6198 22.7935C20.0773 25.3076 11.9229 25.3076 4.38042 22.7935C4.18888 22.7296 4.11048 22.5011 4.22247 22.3331L4.8753 21.3539C6.04342 19.6017 6.66676 17.5429 6.66676 15.4371V12Z",
    stroke: "#9898B3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.8590d031d81a9b1771b9631cbfd58701.svg";
export { ForwardRef as ReactComponent };